'use strict';

module.exports = [
  '$modal',
  '$scope',
  StatusRejectionDialogController];

function StatusRejectionDialogController($modal, $scope) {
  $scope.submit = $modal.hide.bind($modal);

  $scope.cancel = $modal.cancel.bind($modal);
}


// WEBPACK FOOTER //
// ./src/js/core-components/selectors/status-selector-directive/StatusRejectionDialogController.js